import script from "./StepperItem.vue?vue&type=script&setup=true&lang=js"
export * from "./StepperItem.vue?vue&type=script&setup=true&lang=js"

import "./StepperItem.vue?vue&type=style&index=0&id=3d2b66b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d2b66b4"]])

export default __exports__